import AppLocales from '../locales/app.locales.json'
import ChartLocales from '../locales/charts.locales.json'

export enum LANGUAGES {
  FR = 'fr', EN = 'en'
}

export enum LOCALES {
  FR = 'fr-FR',
  EN = 'en-EN'
}

class I18n {
  readonly locales: any
  language: LANGUAGES
  constructor() {
    this.language = this.getLanguage()
    console.info('lang is ', this.language)
    const Locales = {
      fr: { ...AppLocales.fr, ...ChartLocales.fr },
      en: { ...AppLocales.en, ...ChartLocales.en }
    } as const
    this.locales = Locales[this.language]
  }

  getLanguage() {
    if (this.pageInEnglish()) { return LANGUAGES.EN }
    else { return LANGUAGES.FR }
  }

  pageInEnglish() {
    try {
      const wglang = localStorage.getItem('wglang')
      return wglang === LANGUAGES.EN
    } catch (error) {
      console.warn('Error accessing Weglot:', error)
      return false
    }
  }

  t(entry: string) {
    const value = this.locales[entry]
    if (!value) {
      console.warn(`translation missing for ${entry} in ${this.language}`)
    }
    return value
  }

  getLocale(): LOCALES {
    const locale = this.getLanguage() === LANGUAGES.FR ? LOCALES.FR : LOCALES.EN
    return locale
  }

  parse(elem: HTMLElement, selector = 'i18n'): HTMLElement {
    const clonedContent = elem.cloneNode(true) as HTMLElement
    const nodes = clonedContent.querySelectorAll(`[${selector}]`)
    nodes.forEach(el => {
      const key = el.getAttribute(selector)
      if (key) el.textContent = this.t(key)
    })
    return clonedContent
  }
}

export const i18n = new I18n()